import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import * as RadioButton from 'components/RadioButton';

const TailTypeRadioButtonComponent = props => (
  <Field
    type="radio"
    name="tailType"
    value={props.value}
    labelClassName="ml-30"
    onChange={props.onChange}
    component={RadioButton.ReduxFormWrapper}
  >

    {props.children}
  </Field>
);

TailTypeRadioButtonComponent.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,

  children: PropTypes.node.isRequired
};

export default TailTypeRadioButtonComponent;
